<img [src]="url" [alt]="alt || autoAlt" />
